// extracted by mini-css-extract-plugin
module.exports = {"tooltipContents":"tooltip_tooltipContents__quule"};